module.exports = __webpack_public_path__ + "static/media/team_converse.1a960ba2.png";